export const download = (image: string, fileName = 'screenshot.png') => {
    const a = document.createElement('a')
    a.href = image
    a.download = fileName
    a.click()
}
